import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "666ae920-9eab-48a3-8a34-781e1b178ab0",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText: "The reverberant sound pressure level in the room (assume ideal diffuse field): L<sub>r</sub> = ",
    suffixText: "dB",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 93.5,
};
